<ngb-timepicker #timepicker [formControl]="control" [readonlyInputs]="!allowManual"
    [seconds]="style === 'HH:mm:ss'" [hourStep]="hourStep" [minuteStep]="minuteStep"
    [secondStep]="secondStep" [spinners]="spinners"></ngb-timepicker>